import request from 'axios';
export const axiosPost = request.create({
    xsrfHeaderName: 'X-CSRF-Token',
    withCredentials: true,
    headers:{'Content-Type':"application/json; charset=utf-8"}
});
/*
// ここでインターセプターを追加
axiosPost.interceptors.request.use((config) => {
  const tabKey = sessionStorage.getItem("tabKey"); // タブごとに保持しているキー
  console.log(tabKey);
  if (tabKey) {
    config.headers["X-Tab-Key"] = tabKey;  // ヘッダに追加
    // クエリパラメータで送りたいなら ↓ のように
    // config.params = { ...(config.params || {}), tabKey };
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});
*/
//export const server = "http://localhost:8080";
export const header = {'Content-Type':"application/json; charset=utf-8"};
export const server = "https://www.wakocs.jp/wqc";
//export const server = "http://202.222.80.238/wqc";
//export const server = "http://153.120.21.52:8080/wqc";
